import type { IShapeOfField } from "@/utils/zod";
import { z } from "@/utils/zod";

export interface IStudentLoginFormSchema {
  phoneNumber: string;
  password: string;
}

export const studentLoginFormInitialValues: IStudentLoginFormSchema = {
  phoneNumber: "",
  password: "",
};

export const studentLoginFormValidationSchema = z.object<
  IShapeOfField<IStudentLoginFormSchema>
>({
  phoneNumber: z.string().min(1),
  password: z.string(),
});
